import { singleton } from "tsyringe";
import BaseApi from "../BaseApi";

@singleton()
export default class FileApi extends BaseApi {
	private baseurl = `${this.apiUrl}/files`;

	public getFileUrl(folder: string, fileId: string): string {
		return `${this.baseurl}/${folder}/${fileId}`;
	}

	public async downloadFile(folder: string, fileId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.baseurl}/${folder}/${fileId}`);
	}
}
